import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import GerberFile from 'shared/components/parameters/GerberFile';
import { processFile as processZipFile } from 'shared/product_tabs/tab_parts/slice/process_file';
import { selectFabricationDataForZipFile } from 'us_full_feature_pcb/pcb_fabrication/slice/selectors';

const tooltip = `For Fabrication please include in the Zip File:
- Gerber files.
- Fabrication Notes (if available)
- Fabrication Drawings (if available)

For Assembly please include in the Zip File:

- BOM
- XY Data
- Assembly Drawings (If available)
- Assembly Notes (if available)`;

const fabRequireFile = (step, destroy, lineItemId) => {
  if (!destroy && lineItemId) return false;

  return true;
};

const stencilRequireFile = (stencils) => {
  if (stencils.length === 0) return false;

  const anyNew = stencils.find((stencil) => !stencil.line_item_id);

  if (anyNew) return true;

  return false;
};

const ZipFile = (props) => {
  const dispatch = useDispatch();
  const {
    label,
    text,
    parameters,
    onChangeParameter,
    validator,
  } = props;

  const {
    quoteStep: fabricationQuoteStep,
    destroy: fabricationDestroy,
    lineItemId: fabricationLineItemId,
  } = useSelector(selectFabricationDataForZipFile);

  const {
    stencils,
  // eslint-disable-next-line react-redux/useSelector-prefer-selectors
  } = useSelector((state) => state.stencils);

  const processFile = (file) => {
    dispatch(processZipFile(file));
  };

  const requireFile = fabRequireFile(
    fabricationQuoteStep,
    fabricationDestroy,
    fabricationLineItemId
  ) || stencilRequireFile(stencils);

  return (
    <GerberFile
      parameters={parameters}
      onChangeParameter={onChangeParameter}
      processFile={processFile}
      label={label}
      text={text}
      tooltip={tooltip}
      errorMessage={requireFile && validator.message('Zip file', parameters.filename, 'required')} />
  );
};

export default ZipFile;
